import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import rootReducer from './reducers'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

const middleWare = [thunk]
// setting persistence on the browser session
const persistConfig = {
  key: 'root',
  storage: storage
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

// composeEnhancers allows you to trace calls with redux devtools (can be enabled/disabled by swapping the two stores bellow)

// const composeEnhancers = composeWithDevTools({
//   trace: true,
//   traceLimit: 25
// })

const configureStore = () => {
  // creating the redux store with persisted storage, and applying thunk as our middleware
  const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middleWare)))
  // const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleWare)))
  const persistor = persistStore(store)
  return { store, persistor }
}

export default configureStore
